function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg045Slovakia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 166.957,
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 178.076
  }), /*#__PURE__*/React.createElement("rect", {
    y: 345.043,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 166.957
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M83.597,141.308V288.17c0,83.541,109.136,109.137,109.136,109.137S301.87,371.71,301.87,288.17  V141.308H83.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M109.197,141.308V288.17c0,9.807,2.179,19.07,6.493,27.753c42.819,0,106.819,0,154.085,0  c4.315-8.683,6.493-17.946,6.493-27.753V141.308H109.197z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "243.933,243.708 205.536,243.708 205.536,218.108 231.136,218.108 231.136,192.508   205.536,192.508 205.536,166.908 179.936,166.908 179.936,192.508 154.337,192.508 154.337,218.108 179.936,218.108   179.936,243.708 141.533,243.708 141.533,269.308 179.936,269.308 179.936,294.908 205.536,294.908 205.536,269.308   243.933,269.308 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M150.611,351.658c16.496,10.366,33.445,16.386,42.122,19.062c8.677-2.676,25.627-8.696,42.122-19.062  c16.637-10.456,28.299-22.413,34.921-35.736c-7.304-5.168-16.215-8.215-25.843-8.215c-3.505,0-6.911,0.415-10.185,1.178  c-6.938-15.765-22.686-26.778-41.015-26.778s-34.077,11.012-41.015,26.778c-3.273-0.762-6.679-1.178-10.185-1.178  c-9.628,0-18.539,3.048-25.843,8.215C122.312,329.245,133.975,341.202,150.611,351.658z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg045Slovakia);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };